import(/* webpackMode: "eager" */ "/workspace/app/error.tsx");
